import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext, useWatch } from 'react-hook-form';
import { RadioGroupComponent } from '../../../../../components/form/elements/radio-group';
import DealTypes from '../../../../../enums/deal-type';

const LostRadioGroup = () => {
  const { t } = useTranslation();

  const { control } = useFormContext();
  const products = useWatch({
    name: 'products',
    control: control,
  });

  return (
    <RadioGroupComponent
      name={'subtype'}
      buttons={[
        {
          value: DealTypes.lost,
          label: t(`classifiers.${DealTypes.lost}`),
        },
        {
          value: DealTypes.leftover,
          label: t(`classifiers.${DealTypes.leftover}`),
        },
      ]}
      label={null}
      disabled={!!products?.length}
      required={['subtype']}
    />
  );
};

export default LostRadioGroup;
